document.querySelectorAll(".header__column--navigation a.dropdown").forEach((dropdown) => {
  dropdown.onclick = (e) => {
    e.preventDefault();
  }
})
